import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-spotify-image"
export default class extends Controller {
  static targets = ["image", "imagePlaceholder"]
  static values = { selectedUrl: String }


  connect() {
    if (this.selectedUrlValue) {
      this.setImageUrl(this.selectedUrlValue)
    }
  }

  copy(event) {
    if (event.params["url"]) {
      this.setImageUrl(event.params["url"])
    } else {
      this.delete()
    }

  }

  delete() {
    this.imageTarget.src = ""
    this.imageTarget.classList.add("hidden")
    this.imagePlaceholderTarget.classList.remove("hidden")
  }

  // Private

  setImageUrl(url) {
    this.imageTarget.src = url
    this.imageTarget.classList.remove("hidden")
    this.imagePlaceholderTarget.classList.add("hidden")
  }
}
